var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.586 2.66675H10.426C5.55936 2.66675 2.66602 5.56008 2.66602 10.4134V21.5734C2.66602 26.4267 5.55935 29.3201 10.4127 29.3201H21.5727C26.426 29.3201 29.3193 26.4267 29.3193 21.5734V10.4134C29.3327 5.56008 26.4394 2.66675 21.586 2.66675Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.6 19.1999C17.6 20.6132 16.9867 21.8932 16 22.7732C15.1467 23.5466 14.0266 23.9999 12.8 23.9999C10.1466 23.9999 8 21.8532 8 19.1999C8 16.9866 9.5067 15.1199 11.5334 14.5732C12.08 15.9599 13.2667 17.0399 14.7333 17.4399C15.1333 17.5466 15.56 17.6132 16 17.6132C16.44 17.6132 16.8667 17.5599 17.2667 17.4399C17.48 17.9732 17.6 18.5732 17.6 19.1999Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7992 12.8C20.7992 13.4267 20.6792 14.0267 20.4658 14.5733C19.9192 15.96 18.7325 17.04 17.2659 17.44C16.8659 17.5467 16.4392 17.6133 15.9992 17.6133C15.5592 17.6133 15.1325 17.56 14.7325 17.44C13.2658 17.04 12.0792 15.9733 11.5326 14.5733C11.3192 14.0267 11.1992 13.4267 11.1992 12.8C11.1992 10.1467 13.3459 8 15.9992 8C18.6525 8 20.7992 10.1467 20.7992 12.8Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 19.2001C24 21.8534 21.8534 24.0001 19.2 24.0001C17.9734 24.0001 16.8533 23.5334 16 22.7734C16.9867 21.9067 17.6 20.6267 17.6 19.2001C17.6 18.5734 17.48 17.9734 17.2667 17.4267C18.7333 17.0267 19.92 15.9601 20.4666 14.5601C22.4933 15.1201 24 16.9867 24 19.2001Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.158b73ea19e28d2c398d477df376cebe.svg";
export { ForwardRef as ReactComponent };